export class UserRole {
    name: String = 'User role';
    organisationId: number = -1;
    organisationName: string = '';
    permissions: string[] = [];
    companies: number [] = [];
    managedCompanies: number [] = [];
    fullCompanyAccess = false;

    deserialize(data: any): this {
        this.name = data.role_name;
        this.organisationId = data.organisation_id;
        this.organisationName = data.organisation_name;
        this.permissions = data.permissions;
        this.companies = data.companies ?? [];
        this.managedCompanies = data.managed_companies ?? [];
        this.fullCompanyAccess = data.full_company_access ?? false;
        return this;
    }

    serialize(): any {
        return {
            name: this.name,
            organisation_id: this.organisationId,
            organisation_name: this.organisationName,
            permissions: this.permissions,
            companies: this.companies,
            managed_companies: this.managedCompanies,
            full_company_access: this.fullCompanyAccess, 
        };
    }
}

